/** FILTERS */
import axios from 'axios'

import noUiSlider from 'nouislider' // from node_modules

import { PRODUCTLIST as ENDPOINT } from '../common/endpoints'

const ID_PREFIX = 'j-filter__slider-'

const filterSliders = document.querySelectorAll('.c-filter--slider')

const filters = document.querySelector('.j-filters')
const filtersToggleMobile = document.querySelector('.j-filters__toggle-m')
const filtersToggle24h = document.getElementById('switch-shipping')
const filtersLabel24 = document.querySelector('.c-toolbar-toggle__label')
const productListWrapper = document.getElementById('productList')
const filtersForm = document.getElementById('filters-form')
const resultsButton = document.querySelector('.j-filters__btn')
const filtersListCont = document.querySelector('.j-filters__list')
const listingToolbar = document.querySelector('.j-listing-toolbar')
const clearFiltersAll = document.querySelector('.c-filters__clear-button')
const paginationWrapper = document.querySelector('.c-pagination')
let param

const _updateQueryStringParameter = (uri, key, value) => {
	var url = new URL(uri)
	var search_params = url.searchParams
	if (!value) {
		search_params.delete(key)
	} else {		
		search_params.set(key, value)
	}
	
	return url.toString()
	url.search = search_params.toString()

}


// Close filters when the user clicks outside it
const closeFiltersClickOutside = () => {
	document.addEventListener('click', (e) => {
		if (filters.classList.contains('is-active')) {
			// click outside of filters and outside of filter button mobile
			if (!filters.contains(e.target) && !filtersToggleMobile.contains(e.target)) {
				filters.classList.remove('is-active')
			}
		}
	})
}

if (filters) {
	closeFiltersClickOutside()
}

// btn applica filtri
const _clickApplica = () => {
	document.body.scrollTop = 0 // For Safari
	document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
}

// filtri
const clickSuFiltro = async (evt) => {
	
	evt.preventDefault()
	filtersForm.classList.add('is-loading')
	if( evt.target.tagName == 'A' ){
		evt.target.classList.toggle('selected')
	}	
	let _searchParams = {}
	const Lang = window.motostorm?.lang
	const list = window.motostorm.list
	const r = []
	const filtersListingInput = document.querySelectorAll('.j-filter-listing__input')
	const pillsWrapper = document.querySelector('.j-pills__filter')
	const listingSort = document.querySelector('.j-listing__order')
	
	if( evt.target.dataset.type !== 'clear-all' ){ // se click su reset all non passare parametri

		filtersListingInput.forEach((item, key) => {

			switch (item.type) {
				case 'checkbox':
					if (item.checked) {
						if (r[item.dataset.type]){
							r[item.dataset.type] += ":" + item.value
						} else {
							r[item.dataset.type] = item.value
						}
					}
					return						
				case 'radio':
					if (item.checked) {
						r[item.dataset.type] = item.value
					}
					return
				case 'reset':
					r[item.dataset.type] = ''
					return
				default:
				
					if(item.tagName == 'A') {
						// item.dataset.value == marca
						if( evt.target.parentElement.dataset.action == 'clear-multi' && evt.target.parentElement.dataset.type == item.dataset.type && item.dataset.value == evt.target.parentElement.dataset.value){
						
						} else if (evt.target.dataset.action == 'clear-multi' && evt.target.dataset.type == item.dataset.type && item.dataset.value == evt.target.dataset.value) {
							// click on the link but out of label or icon
						} else {

							if( item.classList.contains('selected') ){
								if (r[item.dataset.type]){
									r[item.dataset.type] += ":" + item.dataset.value
								} else {
									r[item.dataset.type] = item.dataset.value
								}							
							}
						}
					} else {
						r[item.dataset.type] = item.value
					}
			}
		})		

		// pills chiudi filtro
		if( evt.target.parentElement.dataset.action == 'clear' || evt.target.dataset.action == 'clear' ){
			
			if(evt.target.parentElement == null || evt.target.parentElement.dataset.type == null){
				param = evt.target.dataset.type
			} else {
				param = evt.target.parentElement.dataset.type
			}
			delete r[param]
			delete list[param]
				console.log(r)
			if( param == 'maxprice' ){
				delete r['minprice']
			}
		}	
		
		// reset gruppo
		if( evt.target.type == 'reset' ){
			r[evt.target.dataset.type] = ''
		}		

		// order
		if( listingSort ){
			r[listingSort.dataset.type] = listingSort.value
		}
		
		// delete empty elments from array
/* 		for (const property in r) {

		  if(`${r[property]}` == ''){
			  delete r.[`${property}`]
		  }
		} */		

	} else {
		if( pillsWrapper ){
			if (!pillsWrapper.classList.contains('is-hidden')) {
				pillsWrapper.classList.add('is-hidden')
			}			
		}		
	}
	
	if (filtersToggle24h && filtersToggle24h.checked){
		r[filtersToggle24h.dataset.type] = filtersToggle24h.value
	}
	
	_searchParams = {
		lang: Lang,
		...list,
		...r
	}
	await axios.get(ENDPOINT, {
		params: _searchParams,
	})
	.then(resp => {
		productListWrapper.innerHTML = resp.data.html
		filtersListCont.innerHTML = resp.data.filters
		listingToolbar.innerHTML = resp.data.toolbar
		resultsButton.innerHTML = resp.data.btresults
		if( paginationWrapper ){
			paginationWrapper.innerHTML = resp.data.pagination
		}
		if( pillsWrapper ){
			if( resp.data.activefilters === true ) {
				pillsWrapper.classList.remove("is-hidden")
			} else {
				pillsWrapper.classList.add("is-hidden")
			}
			// inserisci contenuto
			pillsWrapper.innerHTML = resp.data.pills
		}
		//var param = evt.target.dataset.type
		//var filterType = evt.target.type
		//var inputVal = evt.target.value
		//history.pushState({}, '', _updateQueryStringParameter(filterType, param, inputVal))
		history.pushState({}, '', resp.data.url )
		
		if(filterSliders){
			filterSliders.forEach(function (sliderWrapper) {
				const sliderNode = sliderWrapper.querySelector(`[id^='${ID_PREFIX}']`)
				if( sliderNode.noUiSlider ){
					sliderNode.noUiSlider.destroy()
				}
			})
		}
		
		_initializeFilters()
		
		setTimeout(() => {
		  filtersForm.classList.remove('is-loading')
		  if(resp.data.number == 1){
			filters.classList.remove('is-active') // if results number is 1 close the filters box
		  }
		}, 1000)
		
	})
	.catch(err => {
		// Handle Error Here
		console.error(err);
	})
}

// toggler 24h
const toggleFilter24h = () => {
	
	const filtersToggle24h = document.getElementById('switch-shipping')
	var toggle24hParam = filtersToggle24h.dataset.type
	var toggle24hVal = filtersToggle24h.value

	filtersToggle24h.addEventListener('change', (e) => {
		
		if (filtersLabel24.classList.contains('is-active')) {
			filtersLabel24.classList.remove('is-active')
			window.location.assign( _updateQueryStringParameter( window.location.href, toggle24hParam, '') )
		} else {
			filtersLabel24.classList.add('is-active')
			const uriWithoutPage = _updateQueryStringParameter( window.location.href, 'pag', '') // remove 'pag' parameter
			window.location.assign( _updateQueryStringParameter( uriWithoutPage, toggle24hParam, toggle24hVal) )
		}
	})
}

// inizializzazione filtri
const _initializeFilters = () => {
	
	const filtersListingInput = document.querySelectorAll('.j-filter-listing__input')
	const filtersReset = document.querySelectorAll('.c-filter__reset')
	const filterSliders = document.querySelectorAll('.c-filter--slider')
	const filtersToggle24h = document.getElementById('switch-shipping')
	const listingSort = document.querySelector('.j-listing__order')
	
	filtersListingInput.forEach(item => {
		item.addEventListener('click', clickSuFiltro, false)
	})
	
	filtersReset.forEach(item => {
		item.addEventListener('click', clickSuFiltro, false)
	})
	
	if(listingSort){
		listingSort.addEventListener('change', clickSuFiltro, false)
	}
	
	if(resultsButton){
		resultsButton.addEventListener('click', function(event) {
			event.preventDefault()
			filters.classList.remove('is-active')
			_clickApplica()
		}, false)
	}
	
	if (filterSliders) {
		filterSliders.forEach(function (sliderWrapper) {
			const sliderNode = sliderWrapper.querySelector(`[id^='${ID_PREFIX}']`)
			const id = sliderNode.id.replace(ID_PREFIX, '')
			const inputMinNode = sliderWrapper.querySelector(`#min-${id}`)
			const inputMaxNode = sliderWrapper.querySelector(`#max-${id}`)

			function updateInputs(values) {
				inputMinNode.classList.add('j-filter-listing__input')
				inputMaxNode.classList.add('j-filter-listing__input')
				inputMinNode.value = values[0]
				inputMaxNode.value = values[1]
				inputMinNode.dispatchEvent(new Event('input'))
				inputMaxNode.dispatchEvent(new Event('input'))
			}

			function updateSlider() {
				if (!sliderNode.noUiSlider) {
					return
				}
				const newMin = Math.min(inputMinNode.value, inputMaxNode.value)
				const newMax = Math.max(inputMinNode.value, inputMaxNode.value)

				sliderNode.noUiSlider.set([newMin, newMax])
			}

			noUiSlider.create(sliderNode, {
				start: [Number(sliderNode.dataset.min), Number(sliderNode.dataset.max)],
				connect: [false, true, false],
				step: 1,
				range: {
					min: [Number(sliderNode.dataset.min)],
					max: [Number(sliderNode.dataset.max)],
				},
			})

			sliderNode.noUiSlider.on('set', (value) => updateInputs(value))
			sliderNode.noUiSlider.on('slide', (value) => updateInputs(value))
			sliderNode.noUiSlider.on('set', () => clickSuFiltro(event))
			//sliderNode.noUiSlider.on('slide', () => clickSuFiltro(event))			
			inputMinNode.addEventListener('change', updateSlider)
			inputMaxNode.addEventListener('change', updateSlider)
		})
	}

	if (filtersToggle24h) {
		toggleFilter24h()
	}
	
	if( clearFiltersAll ){
		clearFiltersAll.addEventListener('click', clickSuFiltro)
	}
}

_initializeFilters()
